var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 347.991,
    height: 217.901,
    viewBox: "0 0 347.991 217.901",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347.991,
    height: 217.901,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M347.991,61.667H272.178a108.994,108.994,0,0,0-196.365,0H0v94.567H75.813a108.994,108.994,0,0,0,196.365,0h75.813Z",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.084,155.844h-330V79.172h330Zm-327.766-2.23H337.854V81.4H12.318Z",
    transform: "translate(-1.09 -8.557)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 325.536,
    height: 72.212,
    transform: "translate(11.227 72.845)",
    fill: "#386c9b"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.48,
    height: 1.784,
    transform: "translate(114.972 51.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.491,
    height: 1.784,
    transform: "translate(106.85 59.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24.48,
    height: 1.784,
    transform: "translate(208.539 51.009)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32.491,
    height: 1.784,
    transform: "translate(208.651 59.608)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 78.154,
    height: 1.784,
    transform: "translate(133.622 180.692)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45.326,
    height: 1.784,
    transform: "translate(151.453 190.484)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.463,182.436v-.041A7.268,7.268,0,0,1,131.919,175a7.378,7.378,0,0,1,5.639,2.207l-2,2.309A5.276,5.276,0,0,0,131.9,177.9a4.236,4.236,0,0,0-4.147,4.453v.04a4.247,4.247,0,0,0,4.147,4.494,5.159,5.159,0,0,0,3.759-1.675l2,2.023a7.312,7.312,0,0,1-5.863,2.553,7.218,7.218,0,0,1-7.334-7.354",
    transform: "translate(-13.452 -18.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.781,182.436v-.041a7.6,7.6,0,0,1,15.2-.04v.04a7.6,7.6,0,0,1-15.2.041m11.91,0v-.041a4.344,4.344,0,0,0-4.33-4.493,4.276,4.276,0,0,0-4.29,4.453v.04a4.344,4.344,0,0,0,4.33,4.494,4.276,4.276,0,0,0,4.29-4.453",
    transform: "translate(-15.648 -18.915)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.1,175.276h3.391l3.759,6.046,3.758-6.046H182.4v14.3h-3.125v-9.336l-4.023,6.108h-.082l-3.984-6.046v9.274H168.1Z",
    transform: "translate(-18.169 -18.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.65,175.276h5.842c3.412,0,5.475,2.023,5.475,4.943v.041c0,3.31-2.574,5.026-5.781,5.026H194.8v4.289H191.65Zm5.638,7.211a2.214,2.214,0,0,0,2.492-2.166v-.041c0-1.409-.98-2.165-2.553-2.165H194.8v4.371Z",
    transform: "translate(-20.714 -18.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.211,175.161h2.9l6.128,14.4h-3.288l-1.308-3.207H213.6l-1.307,3.207h-3.208Zm3.31,8.416-1.9-4.637-1.9,4.637Z",
    transform: "translate(-22.598 -18.932)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.219,175.276h2.9l6.7,8.8v-8.8h3.1v14.3H242.25l-6.926-9.09v9.09h-3.1Z",
    transform: "translate(-25.099 -18.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.827,183.937l-5.5-8.661h3.677l3.412,5.74,3.473-5.74h3.574l-5.5,8.6v5.7h-3.146Z",
    transform: "translate(-27.273 -18.944)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.745,56.009h-4.352v-2.9h11.848v2.9H175.89v11.4h-3.146Z",
    transform: "translate(-18.2 -5.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.047,53.109h3.146v5.658H197V53.109h3.146v14.3H197V61.668h-5.8v5.739h-3.146Z",
    transform: "translate(-20.325 -5.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.122,53.109h10.786v2.8h-7.661v2.9h6.742v2.8h-6.742v3h7.763v2.8H209.122Z",
    transform: "translate(-22.603 -5.74)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.076,40.287l-2.323,1.179,1.067,2.1,2.608-1.324.407,1.2-3.727,1.893-3.675-7.238,3.712-1.884.575,1.134-2.432,1.235.895,1.762,2.323-1.18Z",
    transform: "translate(-16.259 -3.914)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166,38.452a.81.81,0,0,0,1.05.593.611.611,0,0,0,.455-.846c-.141-.417-.4-.581-1.187-.6-1.56-.045-2.067-.417-2.353-1.27a1.774,1.774,0,0,1,1.341-2.333,1.82,1.82,0,0,1,2.537,1.188l-1.3.437c-.073-.208-.292-.791-.921-.58a.544.544,0,0,0-.369.742c.126.373.4.473,1.189.5,1.4.04,2.031.357,2.351,1.308.389,1.159-.113,2.065-1.448,2.514a1.91,1.91,0,0,1-2.674-1.2Z",
    transform: "translate(-17.711 -3.658)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.458,31.154l.8-.154-.294-1.524,1.407-.271.293,1.524.942-.182.222,1.155-.941.181.643,3.339c.069.354.172.543.611.458a1.671,1.671,0,0,0,.342-.092l.2,1.035a2.463,2.463,0,0,1-.836.29c-.976.188-1.466-.091-1.678-1.187l-.689-3.571-.8.154Z",
    transform: "translate(-18.964 -3.156)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.41,35.374l0-.08c.077-1.341.693-2.255,1.952-3.541.961-.991,1.187-1.271,1.226-2.063.029-.59-.077-1.011-.659-1.038-.608-.03-.789.46-.854,1.247l-1.38-.067c.072-1.239.661-2.4,2.332-2.32a1.935,1.935,0,0,1,2.024,2.3c-.045.933-.3,1.432-1.37,2.455a6.46,6.46,0,0,0-1.564,1.962l2.917.142-.249,1.217Z",
    transform: "translate(-21.229 -2.973)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.048,33.508c-.589,2.981-1.467,3.915-3.068,3.6s-2.034-1.572-1.457-4.493c.62-3.137,1.717-3.708,3.064-3.442,1.422.281,2.061,1.308,1.462,4.338m-3.107-.67c-.383,1.937-.491,2.954.279,3.106s1.039-.791,1.424-2.744c.4-2.027.424-2.714-.313-2.86-.694-.136-1.012.59-1.39,2.5",
    transform: "translate(-22.62 -3.147)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.913,39.6l.027-.076c.463-1.262,1.319-1.957,2.9-2.822,1.208-.67,1.506-.872,1.774-1.619.2-.557.221-.99-.33-1.186-.573-.205-.889.211-1.18.946l-1.3-.466c.43-1.164,1.33-2.108,2.908-1.544a1.937,1.937,0,0,1,1.268,2.791c-.315.879-.707,1.281-2.026,1.952A6.472,6.472,0,0,0,222.884,39l2.752.985-.592,1.093Z",
    transform: "translate(-23.877 -3.531)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.41,42.99c-1.433,2.678-2.546,3.313-3.982,2.544s-1.487-2.1-.082-4.722c1.507-2.817,2.723-3.044,3.933-2.4,1.277.684,1.589,1.853.131,4.575m-2.774-1.547c-.932,1.739-1.332,2.68-.64,3.05s1.224-.454,2.163-2.208c.976-1.822,1.2-2.471.535-2.826-.623-.334-1.14.268-2.058,1.984",
    transform: "translate(-25.218 -4.12)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.727,130.146V134.4c-6.143,0-7.737,3.071-13.526,3.071-10.4,0-16.657-8.446-16.657-18.724s6.675-18.723,16.361-18.723a12.465,12.465,0,0,1,9.923,4.252,4.906,4.906,0,0,0,1.595-3.012H55.9v13H54.306c-1.595-7.679-5.552-10.869-10.159-10.869-7.737,0-9.923,8.033-9.923,15.357,0,7.265,1.712,15.535,9.509,15.535,4.429,0,6.793-2.894,6.793-7.147,0-2.54-1.064-3.84-4.549-3.84v-1.713H60.685v1.713c-3.367,0-3.957.945-3.957,6.852",
    transform: "translate(-2.869 -10.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.848,119.313a2.684,2.684,0,0,1-2.658-2.245c-.177-1.181-.532-2.008-1.831-2.008-1.536,0-3.78,2.658-3.78,8.092v6.26c0,5.611.708,6.615,4.37,6.615v1.655H69.592v-1.655c3.662,0,4.371-1,4.371-6.615v-8.505c0-5.611-.532-6.615-4.312-6.615v-1.654L79.4,111.28a16.123,16.123,0,0,1,1.182,5.257c1.181-2.953,3.6-5.2,6.26-5.2,3.9,0,5.079,2.657,5.079,4.607a3.089,3.089,0,0,1-3.071,3.366",
    transform: "translate(-7.522 -12.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.459,138.4C103.6,138.4,99,132.493,99,124.754c0-8.091,5.788-13.407,11.991-13.407a9.547,9.547,0,0,1,9.981,9.746,9.3,9.3,0,0,1-.355,2.539H105.966v1.595c.117,5.671,1.653,9.864,7.324,9.864a10.134,10.134,0,0,0,6.969-3.307l1.418,2.067a13.172,13.172,0,0,1-10.219,4.549m-.118-24.158c-2.6,0-4.312,2.067-5.079,6.674h8.623A11.082,11.082,0,0,0,115,119.32c0-3.247-1.122-5.079-3.661-5.079",
    transform: "translate(-10.7 -12.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.549,138.162c-3.427,0-4.608-2.009-5.021-4.135-2.834,2.835-4.842,4.193-7.8,4.193-4.193,0-6.615-2.717-6.615-6.2,0-5.789,5.67-8.742,14.235-10.16v-1.83c0-4.667-.827-6.143-3.6-6.143a3.535,3.535,0,0,0-3.78,3.426,2.628,2.628,0,0,1-2.6,2.776,2.688,2.688,0,0,1-2.718-2.776c0-3.6,4.784-5.966,9.628-5.966,7.087,0,9.686,3.189,9.686,9.156v12.344c0,1.772.532,2.539,1.418,2.539a2.5,2.5,0,0,0,1.712-.826l.886,1.476a7.481,7.481,0,0,1-5.434,2.127m-5.2-14.058c-5.847,1.358-7.974,4.075-7.974,6.969a3,3,0,0,0,3.13,3.308c1.183,0,2.659-.532,4.844-2.658Z",
    transform: "translate(-14.171 -12.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.306,137.464c-4.608,0-6.439-2.54-6.439-7.8V114.074H163.5V111.83c4.843-.768,6.438-3.6,6.911-8.033h3.071v7.561h5.2v2.716h-5.2v15.594c0,2.952.473,4.194,2.363,4.194,1.122,0,2.067-.591,3.248-1.89l1.064,1.712c-1.831,2.363-4.016,3.78-6.852,3.78",
    transform: "translate(-17.672 -11.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.264,137.47c-4.724,0-7.265-2.126-8.918-2.894a6.256,6.256,0,0,0-1.713,2.6h-1.476v-12.64h1.654c.708,4.9,4.607,9.746,10.336,9.746,3.957,0,6.084-2.185,6.084-5.316,0-2.954-3.367-4.9-6.556-6.556l-4.725-2.48a11.118,11.118,0,0,1-6.32-10.219,9.683,9.683,0,0,1,9.982-9.686,10.774,10.774,0,0,1,6.911,2.422,5.433,5.433,0,0,0,1.712-2.422h1.418V111.3H214c-.65-4.489-3.485-8.151-8.27-8.151a4.394,4.394,0,0,0-4.725,4.43c0,2.717,2.186,4.135,6.853,6.615l4.43,2.363c4.193,2.244,6.2,5.847,6.2,9.628,0,6.5-4.312,11.281-11.223,11.281",
    transform: "translate(-21.093 -10.811)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.816,137.464c-4.608,0-6.439-2.54-6.439-7.8V114.074h-3.366V111.83c4.843-.768,6.438-3.6,6.911-8.033h3.071v7.561h5.2v2.716h-5.2v15.594c0,2.952.474,4.194,2.364,4.194,1.121,0,2.067-.591,3.247-1.89l1.064,1.712c-1.831,2.363-4.016,3.78-6.852,3.78",
    transform: "translate(-24.536 -11.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.042,119.313a2.684,2.684,0,0,1-2.658-2.245c-.177-1.181-.532-2.008-1.831-2.008-1.536,0-3.78,2.658-3.78,8.092v6.26c0,5.611.708,6.615,4.37,6.615v1.655H250.786v-1.655c3.662,0,4.371-1,4.371-6.615v-8.505c0-5.611-.532-6.615-4.312-6.615v-1.654l9.745-1.358a16.123,16.123,0,0,1,1.182,5.257c1.181-2.953,3.6-5.2,6.26-5.2,3.9,0,5.079,2.657,5.079,4.607a3.089,3.089,0,0,1-3.071,3.366",
    transform: "translate(-27.106 -12.028)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.654,138.4c-7.856,0-12.463-5.906-12.463-13.645,0-8.091,5.788-13.407,11.991-13.407a9.547,9.547,0,0,1,9.981,9.746,9.3,9.3,0,0,1-.355,2.539H287.161v1.595c.117,5.671,1.653,9.864,7.324,9.864a10.134,10.134,0,0,0,6.969-3.307l1.418,2.067a13.172,13.172,0,0,1-10.219,4.549m-.118-24.158c-2.6,0-4.312,2.067-5.079,6.674h8.623a11.082,11.082,0,0,0,.118-1.595c0-3.247-1.121-5.079-3.661-5.079",
    transform: "translate(-30.284 -12.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.243,138.4c-7.856,0-12.463-5.906-12.463-13.645,0-8.091,5.788-13.407,11.991-13.407a9.547,9.547,0,0,1,9.981,9.746,9.3,9.3,0,0,1-.355,2.539H318.75v1.595c.117,5.671,1.653,9.864,7.324,9.864a10.134,10.134,0,0,0,6.969-3.307l1.418,2.067a13.172,13.172,0,0,1-10.219,4.549m-.118-24.158c-2.6,0-4.312,2.067-5.079,6.674h8.623a11.082,11.082,0,0,0,.118-1.595c0-3.247-1.121-5.079-3.661-5.079",
    transform: "translate(-33.698 -12.035)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.845,137.464c-4.608,0-6.439-2.54-6.439-7.8V114.074H343.04V111.83c4.843-.768,6.438-3.6,6.911-8.033h3.071v7.561h5.2v2.716h-5.2v15.594c0,2.952.473,4.194,2.363,4.194,1.122,0,2.067-.591,3.248-1.89l1.064,1.712c-1.831,2.363-4.016,3.78-6.852,3.78",
    transform: "translate(-37.077 -11.219)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.07,237.131H247.7v-1.219h6.077v1.219H251.4V243.4H250.07Z",
    transform: "translate(-26.772 -25.498)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.072,235.911h1.4l2.278,3.541,2.279-3.541h1.4V243.4h-1.316v-5.37l-2.364,3.53h-.042l-2.343-3.51v5.35h-1.294Z",
    transform: "translate(-27.677 -25.498)",
    fill: "#214669"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.574,175.22a96.409,96.409,0,0,1-167.961,0H98.049l.308.553a98.656,98.656,0,0,0,172.473,0l.308-.553Z",
    transform: "translate(-10.597 -18.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.623,62.855a96.408,96.408,0,0,1,167.941,0h2.564l-.3-.542a98.655,98.655,0,0,0-172.465,0l-.3.542Z",
    transform: "translate(-10.599 -1.252)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.f8032279917dbc7aea60221fff2b8378.svg";
export { ForwardRef as ReactComponent };